// this is the hash of the empty code (SHA3_NULL)
module.exports = new Buffer('c5d2460186f7233c927e7db2dcc703c0e500b653ca82273b7bfad8045d85a470', 'hex');